module.exports = "pegasus_template/assets/themelp1/small/30.png";